module.exports = __webpack_public_path__ + "static/assets/58e4ffd30e88bef70209f8a88da3f5ca.png";